module.exports = __webpack_public_path__ + "img/headshot-mtaveras.dabbf7bc.png";